<style lang="less">
.app-header {
  color: rgba(49, 58, 70, 0.8);

  .h-autocomplete {
    line-height: 1.5;
    float: left;
    margin-top: 15px;
    margin-right: 20px;
    width: 120px;
    &-show,&-show:hover, &-show.focusing {
      outline: none;
      box-shadow: none;
      border-color: transparent;
      border-radius: 0;
    }
    &-show.focusing{
      border-bottom: 1px solid #eee;
    }
  }
  &-info &-icon-item {
    cursor: pointer;
    display: inline-block;
    float: left;
    padding: 0 15px;
    height: @layout-header-height;
    line-height: @layout-header-height;
    margin-right: 10px;
    &:hover {
      background: @hover-background-color;
    }
    i {
      font-size: 18px;
    }
    a {
      color: inherit;
    }
    .h-badge {
      margin: 20px 0;
      display: block;
    }
  }
  .h-dropdownmenu {
    float: left;
  }

  &-dropdown{
    float: right;
    margin-left: 10px;
    padding: 0 20px 0 15px;
    .h-icon-down {
      right: 20px;
    }
    cursor: pointer;
    &:hover, &.h-pop-trigger {
      background: @hover-background-color;
    }
    &-dropdown {
      padding: 5px 0;
      .h-dropdownmenu-item {
        padding: 8px 20px;
      }
    }
  }

  &-menus{
    display: inline-block;
    vertical-align: top;
    >div {
      display: inline-block;
      font-size: 15px;
      padding: 0 25px;
      color: @dark-color;
      &:hover{
        color: @primary-color;
      }
      +div {
        margin-left: 5px;
      }
      &.h-tab-selected{
        color: @white-color;
        background-color: @primary-color;
      }
    }
  }
}
.app-header-dropdown {
    margin-left: 0px;
    padding: 0 38px 0 15px;

    @media(max-width: 600px){
      padding: 0 10px 0 11px;
    }
}
// customização do header (compacto) - icone notificação
.app-header-info .app-header-icon-item .h-badge {
  margin: 13px 0;
}

/* alteração header vendas - deixa laranja */
.h-layout-header{
  background: #3c454f;
}
.header-btn-toogle{
  background: transparent;
  color: #fff;
}
.header-btn-toogle:hover{
  background: transparent;
  color: #eee;
}
.app-header {
  color: #fff;
}
.app-header-info .app-header-icon-item{
  transition: 0.2s;
}
.app-header-info .app-header-icon-item:hover,
.app-header-dropdown:hover, .app-header-dropdown.h-pop-trigger {
    background: #30373f;
}
.app-header-message-vue .h-dropdowncustom-show.h-pop-trigger {
    background: #30373f;
}
.h-dropdowncustom-show > .h-icon-down {
  color: #fff;
}
.app-message-dropdown-dropdown-container .message-list-container .common-list-item .title {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.h-badge .h-badge-count-show{
    background: rgba(255, 82, 82, 1);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
    animation: pulse-red 2s infinite;
  }
  @keyframes pulse-red {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
    }
  }
</style>

<template>
  <div class="app-header">
    <ModalConfigs @closeModalConfig="handleOpenModalConfig(false)" :isOpen="isModalConfigOpen"/>
    <div style="width:50px;float:left;"><Button aria-label="sider collapsed" :icon="siderCollapsed ? 'icon-align-right':'icon-align-left'" size="l" noBorder class="font20 header-btn-toogle" @click="siderCollapsed=!siderCollapsed"></Button></div>
    <div class="float-right app-header-info">
      <a  @click="handleOpenModalConfig(true)" class="app-header-icon-item app-header-icon-item-visible" v-tooltip content="Configurações" theme="white" style="line-height: 50px;color:#fff !important;">
        <i class="h-icon-setting"></i>
      </a>
      <a href="#/arquivos/upload" id="v-step-4" class="app-header-icon-item app-header-icon-item-visible" v-tooltip content="Importar arquivos" theme="white" style="line-height: 50px;color:#fff !important;">
        <i class="h-icon-upload"></i>
      </a>
      <a href="https://f360.zendesk.com/hc/pt-br/categories/360003297874-F360-Performance" class="app-header-icon-item app-header-icon-item-visible" target="_blank" v-tooltip content="Ajuda" theme="white" style="line-height: 50px;color:#fff !important;">
        <i class="h-icon-help"></i>
      </a>
      <appHeaderMessage></appHeaderMessage>
      <DropdownMenu className="app-header-dropdown" trigger="click" offset="0,5" :width="150" placement="bottom-end" :datas="infoMenu" @onclick="trigger">
        <!-- <Avatar :src="`${require('@/images/avatar.png')}`" :width="30"><span></span></Avatar> -->
        <span><strong>{{user.nome}} {{ widthDevice >= 600 ? `(${user.cliente})` : '' }}</strong></span>
      </DropdownMenu>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import appHeaderMessage from './modules/app-header-message';
import ModalConfigs from '../views/configuracoes/ModalConfigs.vue';
import { regras } from '../../js/config/permissions';

export default {
  components: {
    appHeaderMessage,
    ModalConfigs
  },
  data() {
    return {
      user: {},
      searchText: '',
      widthDevice: window.innerWidth,
      infoMenu: [
        { key: 'f360', title: 'Finanças 360', icon: 'h-icon-link' },
        { key: 'logout', title: 'Sair', icon: 'h-icon-outbox' }
      ],
      isModalConfigOpen: false
    };
  },
  computed: {
    ...mapState(['User']),
    siderCollapsed: {
      get() {
        return this.$store.state.siderCollapsed;
      },
      set(value) {
        this.$store.commit('updateSiderCollapse', value);
      }
    }
  },
  mounted() {
    this.user = Utils.getLocalJson('v360.user');
    const resizeEvent = window.addEventListener('resize', () => {
      this.widthDevice = window.innerWidth;
      if (this.siderCollapsed && window.innerWidth > 900) {
        this.siderCollapsed = false;
      } else if (!this.siderCollapsed && window.innerWidth < 900) {
        this.siderCollapsed = true;
      }
    });
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', resizeEvent);
    });
    window.dispatchEvent(new Event('resize'));
  },
  methods: {
    trigger(data) {
      if (!data) {
        this.$router.push({ name: 'AccountBasic' });
        return;
      }

      const actions = {
        'logout': () => { window.location.href = `${process.env.VUE_APP_URL_HUB}/#/logout`; },
        'f360': () => { window.open(process.env.VUE_APP_FINANCAS_360); }
      };
      actions[data]();
    },
    showSettingModal() {
      this.$emit('openSetting');
    },
    handleOpenModalConfig(action) {
      this.isModalConfigOpen = action;
    },
    permissionConfig() {
      const permissaoRegras = Utils.getPermission(regras.regras);
      return !permissaoRegras;
    }
  }
};
</script>
